export enum AllOrderTableColumnsKeys {
  PatientName = "patientName",
  PlanDetails = "planDetails",
  Authorization = "authorizationId",
  AuthRequired = "authRequired",
  Priority = "priority",
  Type = "type",
  DateOfService = "dateOfService",
  Location = "location",
  Status = "status",
  DocId = "docId",
  AssignedTo = "assignedTo",
}

export enum PatientOrdersTableColumnKeys {
  AUTH_ID = "authId",
  SUBMISSION_DATE = "submissionDate",
  SUBMITTED_BY = "submittedBy",
  PLAN_NAME = "planName",
  LOCATION = "location",
  PRIORITY = "priority",
  DATE_OF_SERVICE = "dateOfService",
  AUTH_REQUIRED = "authRequired",
  STATUS = "status",
  DOC_ID = "docId",
}

export enum PatientsTableColumnKeys {
  PatientName = "patientName",
  PatientId = "patientId", // MRN
  PlanId = "planId", // Member id
  PlanName = "planName",
  Dob = "dob",
  State = "state",
  PrimaryProvider = "primaryProvider",
}

export enum CptCodeWithDetailsKeys {
  JCodeID = "jCodeId",
  StartFrom = "startFrom",
  EndAt = "endAt",
  JCodes = "jCodes",
  Description = "description",
  PaRequired = "paRequired",
  Visits = "visits",
  RemainingVisits = "remainingVisits",
  VisitsAllowed = "visitsAllowed",
  Documents = "documents",
  DocWithUploadIcon = "docWithUploadIcon",
}

export enum NarAgentGridTableColumnKeys {
  Insurance = "insurance",
  Plan = "plan",
  JCode = "jCode",
  DrugName = "drugName",
  UpdatedAt = "updatedAt",
  AgentMode = "agentMode",
}

export enum DrugTableForExternalKeys {
  JCodeID = "jCodeId",
  StartFrom = "startFrom",
  EndAt = "endAt",
  JCodes = "jCodes",
  Description = "description",
  PaRequired = "paRequired",
  Visits = "visits",
  RemainingVisits = "remainingVisits",
  VisitsAllowed = "visitsAllowed",
}

export enum MemberTableColumnKeys {
  Name = "name",
  Status = "status",
  Email = "email",
  Role = "roleId",
  Options = "adminOptions",
}

export enum EligibilityErrorTableColumnKeys {
  PatientName = "patientName",
  PayerDetails = "payerDetails",
  Authorization = "authorizationId",
  AuthRequired = "authRequired",
  Priority = "priority",
  Type = "type",
  OrderDate = "orderDate",
  Location = "location",
  DocId = "docId",
  Error = "error",
}

export enum CmmOrderTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  MEDICATION = "medication",
  PROVIDER_DETAILS = "providerDetails",
  DATE_OF_BIRTH = "dateOfBirth",
  INSURANCE_STATE = "insuranceState",
  ACTION = "button",
  STATUS = "status",
  CMM_KEY = "cmmKey",
  FORM_NAME = "formName",
  ID = "id",
  DELETE_ICON = "cmmOrderDeleteIcon",
  PATIENT_ID = "patientId",
  ROW_DATA = "rowData",
  NO_DATA_FIELDS = "noDataFields",
}

export enum NycbsPharmaOrderDataKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_BIRTH = "dateOfBirth",
  MEDICATION = "medication",
  PROVIDER_DETAILS = "providerDetails",
  DATE_OF_SERVICE = "dateOfService",
  ASSIGNEE = "assignee",
  KEY = "key",
  STATUS = "status",
}

export enum DiagnosisCodeTableColumnKeys {
  ICD_10_CODE = "icd10Code",
  DESCRIPTION = "description",
  DRUG_NAME = "drugName",
  DIAGNOSIS_DATE = "diagnosisDate",
  LAST_VERIFIED_DATE = "lastVerifiedDate",
  IS_PRIMARY = "isPrimary",
  IS_SECONDARY = "isSecondary",
  CONFIDENCE_SCORE = "confidenceScore",
  SOURCE = "source",
  VIEW_THINKING = "viewThinking",
}

export enum EligibilityCheckTableColumnKeys {
  ID = "id",
  CREATED_AT = "createdAt",
  REPORT_DATE = "reportDate",
  STATUS = "status",
  DOWNLOAD_FILE = "downloadFile",
  VIEW_DETAILS = "viewDetails",
  TOTAL_ORDERS = "totalOrders",
}

export enum ProcessedOrdersTableColumnKeys {
  ID = "id",
  CREATED_AT = "createdAt",
  PATIENT_MRN = "patientMrn",
  DRUG_NAME = "drugName",
  STATUS = "status",
  RE_RUN_ONCO_EMR = "reRunOncoEmr",
  RE_RUN_CMM = "reRunCmm",
  VIEW_CMM_INPUT = "viewCmmInput",
}

export enum MedicalPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  STATUS = "status",
  SELECT = "select",
  PDF_EMBED_PAGE = "pdfEmbedPage",
  BO_VALUE = "boValue",
  AUTH_STATUS = "authStatus",
  LOCATION = "location",
  PROVIDER = "provider",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
}

export enum MyPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  PROVIDER = "provider",
  BO_VALUE = "boValue",
  RPA_STATUS = "rpaStatusForAlgolia",
  RPA_STATUS_TWO = "rpaStatusTwo",
  TAG_WITH_ICON = "tagWithIcon",
  ALERTS = "alerts",
}

export enum AuthorizedPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  PROVIDER = "provider",
  BO_VALUE = "boValue",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
}

export enum AuthOnFilePaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  PROVIDER = "provider",
  BO_VALUE = "boValue",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
}

export enum NarPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  PROVIDER = "provider",
  BO_VALUE = "boValue",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
}

export enum PendingPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
  BO_VALUE = "boValue",
  AUTH_STATUS = "authStatus",
  PROVIDER = "provider",
}

export enum DeniedPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
  BO_VALUE = "boValue",
  AUTH_STATUS = "authStatus",
  PROVIDER = "provider",
}

export enum NotToWorkPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
  BO_VALUE = "boValue",
  PROVIDER = "provider",
}

export enum NotToWorkFedoraPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
  BO_VALUE = "boValue",
  PROVIDER = "provider",
}
export enum NotToWorkStatCasePaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  PROVIDER = "provider",
  BO_VALUE = "boValue",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
}

export enum PodPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  PROVIDER = "provider",
  BO_VALUE = "boValue",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
}

export enum FinancialPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
}

export enum HoldPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
  BO_VALUE = "boValue",
  AUTH_STATUS = "authStatus",
  PROVIDER = "provider",
}

export enum GenericAuthStatusTableColumnKeys {
  PATIENT_DETAILS_WITH_LEFT_BORDER = "patientDetailsWithLeftBorder",
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  DATE_OF_WORK = "date_of_work",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  RPA_STATUS = "rpaStatusForAlgolia",
  RPA_STATUS_TWO = "rpaStatusTwo",
  BO_VALUE = "boValue",
  AUTH_STATUS = "authStatus",
  PROVIDER = "provider",
  SIDE_MODAL_ICON = "sideModalIcon",
  LAST_CHECKED = "last_Checked",
  HOLD_UNTIL = "holdUntil",
}

export enum PharmaPaDiffTableColumnKeys {
  PATIENT_DETAILS = "pharmaPaDiffPatientDetails",
  DATE_OF_SERVICE = "pharmaPaDiffDateOfService",
  MEDICATION = "pharmaPaDiffMedication",
  FORM_NAME = "pharmaPaDiffFormName",
  ROW_DATA = "pharmaPaDiffRowData",
  STATUS = "pharmaPaDiffStatus",
  CMM_KEY = "pharmaPaDiffCmmKey",
  VIEW_COMMENT = "pharmaPaDiffViewComment",
  ACTION = "pharmaPaDiffAction",
  ID = "id",
  COMMENT = "pharmaPaDiffComment",
  NO_DATA_FIELDS = "pharmaPaDiffNoDataFields",
  FORM_DIFF_FIELDS = "pharmaPaDiffFormDiffFields",
  QA_DIFF_FIELDS = "pharmaPaDiffQaDiffFields",
  STATUS_STRING = "pharmaPaDiffStatusString",
  COMMENT_STRING = "pharmaPaDiffCommentString",
}

export enum PharmaPaDiffFilterKeys {
  FormName = "form_name",
  DateOfService = "date_of_service",
  Status = "status",
  DrugName = "drug_name",
}

export enum PharmfillPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
}

export enum QueryPaOrdersTableColumnKeys {
  PATIENT_DETAILS = "patientDetails",
  DATE_OF_SERVICE = "dateOfService",
  PLAN_DETAILS = "planDetails",
  MEDICATION = "medication",
  ASSIGNEE = "assignee",
  ROW_DATA = "rowData",
  STATE = "state",
  ID = "id",
  CREATED_AT = "created_at",
  AUTH_VERIFICATION = "authVerification",
  FINAL_STATUS = "finalStatus",
  PROVIDER = "provider",
  BO_VALUE = "boValue",
  RPA_STATUS = "rpaStatus",
  RPA_STATUS_TWO = "rpaStatusTwo",
}

export enum AuditTrialTableColumnKeys {
  TIMESTAMP = "timestamp",
  ACTIONS = "actions",
  EVENT_TYPE = "eventType",
  VIEW_INFO = "viewInfoForAuditTrial",
  ROW_DATA = "rowData",
  VIEW_SCREENSHOT = "viewScreenshot",
  VIEW_PDF = "viewPdf",
}
